import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import asideModalStore from 'Stores/asideModalStore'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import st from './ClientProfileCRM.module.scss'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import AddClient from './AddClient/AddClient'
import { ClientDataList } from './ClientDataList/ClientDataList'
import Pagination from 'components/UI/Pagination/Pagination'
import { superAxiosRequest } from 'axiosApi'
import swal from 'sweetalert'
import TabMenuCrm from 'components/CRM/UI/components/TabMenuCrm/TabMenuCrm'
import { useHistory, useLocation } from 'react-router-dom'

const initPagination = {
  page: 1,
  limit: 10,
}

const ClientProfileCRM = () => {
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      phone_number: 'Phone number',
      name: 'Name',
      connect: 'Сonnect the client',
      save: 'Save',
      edit_client: 'Edit client',
      clients: 'Clients',
      create_client: 'Create a client',
      all_client: 'All clients',
      activated_clients: 'Activated client',
      deactivated_clients: 'Deactivated client',

      are_you_sure: 'Are you sure',
      confirm_client_activation: 'Are you sure you want to activate the client',
      deactivate_client_confirmation:
        'Are you sure you want to deactivate the client',
      no: 'No',
      yes: 'Yes',
      client_not_verified: 'Client is not verified',
      no_user_found_phoenix: 'No user was found in the Phoenix',
      client_verified: 'Client is verified',
      client_verification: 'Client verification',
    },
  })

  const createTabs = (data) => [
    {
      id: 1,
      name: translate?.all_client,
      count: data?._meta.total_clients,
    },
    {
      id: 2,
      name: translate?.activated_clients,
      count: data?._meta.total_active_clients,
    },
    {
      id: 3,
      name: translate?.deactivated_clients,
      count: data?._meta.total_clients - data?._meta.total_active_clients,
    },
  ]

  const [pagination, setPagination] = useState(initPagination)
  const [clients, setClients] = useState(null)
  const [filter, updateFilter] = useLocalStorageFilter({})
  const [tabID, setTabID] = useState(1)
  const [tabs, setTabs] = useState([])
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const history = useHistory()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const clientEmail = queryParams.get('email')
  const clientName = queryParams.get('name')
  const clientPhone = queryParams.get('phone')

  const onChangeTab = (tab) => {
    setTabID(tab.id)
  }

  useEffect(() => {
    const newFilter = { ...filter }
    let hasChanges = false

    const fieldsToUpdate = []

    if (clientEmail && clientEmail !== 'null' && clientEmail.trim() !== '') {
      newFilter.email = clientEmail
      hasChanges = true
      fieldsToUpdate.push({
        key: 'email',
        label: 'Email',
        value: clientEmail,
      })
    }

    if (clientName && clientName !== 'null' && clientName.trim() !== '') {
      newFilter.name = clientName
      hasChanges = true
      fieldsToUpdate.push({
        key: 'name',
        label: 'Search for client name',
        value: clientName,
      })
    }

    if (clientPhone && clientPhone !== 'null' && clientPhone.trim() !== '') {
      newFilter.phone = clientPhone
      hasChanges = true
      fieldsToUpdate.push({
        key: 'phone',
        label: 'Phone number',
        value: clientPhone,
      })
    }

    if (hasChanges) {
      updateFilter(newFilter)

      fieldsToUpdate.forEach((field) => {
        const existingField = filterTextValues.find((f) => f.key === field.key)
        if (existingField) {
          AsideFilterStore.deleteTextValue(field.key)
        }
      })

      fieldsToUpdate.forEach((field) => {
        changeTextValue(field.key, field)
      })
    }
  }, [])

  const fetchClients = () => {
    const params = {
      ...filter,
      ...(tabID === 3 && { is_active: false }),
      ...(tabID === 2 && { is_active: true }),
      offset: (pagination.page - 1) * pagination.limit,
      limit: pagination.limit,
    }

    Object.keys(params).forEach((key) => {
      if (
        params[key] === null ||
        params[key] === undefined ||
        params[key] === 'null'
      ) {
        delete params[key]
      }
    })

    superAxiosRequest({
      method: 'get',
      link: 'integration/clients',
      crm: true,
      params: params,
    }).then(({ data }) => {
      setClients(data)
      setTabs(createTabs(data))
    })
  }

  useEffect(() => {
    setClients(null)
    fetchClients()
  }, [filter, pagination, tabID, translate])

  const config = [
    {
      nameState: 'name',
      placeholder: translate?.name,
      type: 'input',
      label: translate?.name,
    },
    {
      nameState: 'phone',
      placeholder: translate?.phone_number,
      type: 'input',
      label: translate?.phone_number,
    },
    {
      nameState: 'email',
      placeholder: 'Email',
      type: 'input',
      label: 'Email',
    },
  ]
  const onBeforeSubmitClient = (data) => {
    const { whatsapp, inn, instagram, telegram, level, comment, ...rest } = data
    return {
      ...rest,
      phone: data.phone,
      ...(whatsapp && { whatsapp: `+${data.whatsapp}` }),
      ...(inn && { inn: data.inn }),
      ...(instagram && { instagram: data.instagram }),
      ...(telegram && { telegram: data.telegram }),
      ...(level && { level: data.level }),
      ...(comment && { comment: data.comment }),
    }
  }

  const createClient = () => {
    const ms = {
      modalBodyComponent: () => <AddClient />,
      button: translate?.save,
      link: 'integration/clients',
      crm: true,
      title: translate?.connect,
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchClients()
      },
      valid: {
        name: 'required',
        phone: 'required',
        // email: 'required_email',
        inn: 'valid_inn',
      },
    }
    const md = {}
    asideModalStore.activity(ms, md)
  }

  const editClient = (data) => {
    const ms = {
      modalBodyComponent: () => <AddClient edit />,
      button: translate?.save,
      link: `integration/clients/${data?.id}`,
      crm: true,
      is_put: true,
      title: translate?.edit_client,
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setClients((prev) => {
          return {
            ...prev,
            result: prev.result.map((client) =>
              client.id === data.id ? { ...client, ...data } : client,
            ),
          }
        })
      },
      valid: {
        name: 'required',
        phone: 'required',
        // email: 'required_email',
        inn: 'valid_inn',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const activateClient = (data) => {
    swal({
      title: `${translate.are_you_sure}?`,
      text: `${translate.confirm_client_activation}?`,
      icon: 'warning',
      buttons: [translate.no, translate.yes],
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const apiConf = {
          method: 'patch',
          crm: true,
          link: `integration/clients/${data?.id}`,
        }
        superAxiosRequest(apiConf, { is_active: true }).then(() => {
          fetchClients()
        })
      }
    })
  }

  const deactivateClient = (data) => {
    swal({
      title: `${translate.are_you_sure}?`,
      text: `${translate.deactivate_client_confirmation}?`,
      icon: 'warning',
      buttons: [translate.no, translate.yes],
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const apiConf = {
          method: 'patch',
          crm: true,
          link: `integration/clients/${data?.id}`,
        }
        superAxiosRequest(apiConf, { is_active: false }).then(() => {
          fetchClients()
        })
      }
    })
  }

  const clientVerification = (data) => {
    const apiConf = {
      method: 'post',
      crm: true,
      link: `integration/verify_client`,
    }
    superAxiosRequest(apiConf, { client_id: data?.id })
      .then((data) => {
        const userNotFound = data?.data?.info === 'No user was found'
        swal({
          title: translate.client_verification,
          text:
            data?.data?.info === 'No user was found'
              ? data?.data?.info
              : translate.client_verified,
          dangerMode: true,
        }).then((value) => {
          if (userNotFound && value) {
            window.location.href = '/c/company/clients-profiles'
          }
        })
        fetchClients()
      })
      .catch((error) => {
        swal({
          title: translate.client_not_verified,
          text: error?.response?.data?.info,
          dangerMode: true,
        }).then((value) => {
          if (value) {
            window.location.href = '/c/company/clients-profiles'
          }
        })
      })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit_client', () => editClient(items)],
      ['activate_client', () => activateClient(items)],
      ['deactivate_client', () => deactivateClient(items)],
      ['client_verification', () => clientVerification(items)],
    ])
    return actions.get(action)?.()
  }

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/crm/clients-profiles') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  return (
    <div>
      <div className={st.header}>
        <div>
          <PageHeader title={translate?.clients}>
            <HeaderAddButton
              title={translate?.create_client}
              onClick={createClient}
            />
          </PageHeader>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, name: text })
              setPagination(initPagination)
              changeTextValue('name', {
                key: 'name',
                label: 'Search for client name',
                value: text,
              })
            }}
            onClear={() => {
              const { name: text, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'name'),
              )
            }}
            value={filter?.name || ''}
            placeholder={`${translate?.search}...`}
            translate={translate}
          />
        </div>
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            getFilterParams={(e) => {
              updateFilter(e)
              setPagination({ ...pagination, page: 1 })
            }}
            config={config}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
            translate={translate}
          />
        )}
        <TabMenuCrm
          tabs={tabs}
          onChange={onChangeTab}
          tabID={tabID}
          count={clients?.result.length}
        />
      </div>
      <div className={st.conteinerClient}>
        <div className={st.quantityClients}>
          {tabs.find((tab) => tab.id === tabID)?.name}:{' '}
          {tabs.find((tab) => tab.id === tabID)?.count}
        </div>
        <div>
          {clients?.result.map((client, index) => (
            <ClientDataList
              key={client.id}
              client={client}
              index={index}
              action={action}
            />
          ))}
        </div>
        <div className={st.pagination}>
          {clients?._meta.count_items > 10 && (
            <Pagination
              limit={pagination.limit}
              count={clients._meta.count_items || 0}
              page={pagination.page}
              onChange={(page) => setPagination({ ...pagination, page })}
              onChangePerPage={(limit) => {
                setPagination({ page: 1, limit })
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default observer(ClientProfileCRM)
